/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import Select from 'components/Select';
import {
  EyeOutlined,
  SearchOutlined,
  KeyOutlined,
  AimOutlined,
  UserOutlined,
  UserDeleteOutlined,
} from '@ant-design/icons';
import {
  Col, Row, Card, Input, Tabs, Spin, Form,
} from 'antd';
import React, { useCallback, useState, useEffect } from 'react';
import Diagram, {
  CustomShape,
  Nodes,
  AutoLayout,
} from 'devextreme-react/diagram';
import 'devexpress-diagram/dist/dx-diagram.min.css';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import { Popup } from 'devextreme-react/popup';
import ArrayStore from 'devextreme/data/array_store';
import '../../../themes/organigrama.css';
import logo from 'assets/logo.png';
import { getAllAreas } from 'api/catalogos/DirectorioAreas';
import { getAllEstructurasJerarquicas } from 'api/catalogos/estructuraJerarquica';
import { getAsignacionPlazasOptimized } from 'api/catalogos/plazas';

const styles = {
  popup: {
    padding: '8px 0px',
  },
};

function itemTypeExpr(obj) {
  return `employee${obj.id}`;
}

const wrapText = (text, maxCharsPerLine = 20) => {
  const words = text.split(' ');
  const lines = [];
  let currentLine = '';

  words.forEach((word) => {
    if ((currentLine + word).length <= maxCharsPerLine) {
      currentLine += (currentLine ? ' ' : '') + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  });

  if (currentLine) lines.push(currentLine);

  return lines;
};

const Organigrama_customShape = (employee, showInfo) => {
  const { nombre } = employee;
  return (
    <svg className="template">
      <image
        href={logo}
        x="10"
        y="-20"
        width="80"
        height="80"
      />

      <text
        className="template-name"
        x="50%"
        y="30%"
        textAnchor="middle"
      >
        {wrapText(nombre, 15).map((line, i) => (
          <tspan
            key={line}
            x="50%"
            dy={`${i === 0 ? 0 : 1.2}em`}
          >
            {line}
          </tspan>
        ))}
      </text>
      {/* <text
        className="template-name"
        x="50%"
        y="20%"

        >
        {employee.nombre}
      </text> */}

      <text
        className="template-button"
        x="50%"
        y="85%"
        onClick={showInfo}
      >
        Ver Detalles
      </text>
    </svg>
  );
};

export const Organigrama = () => {
  const [isLoadingVisible, setIsLoadingVisible] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState({});
  const [popupVisible, setPopupVisible] = useState(false);
  const [isSimplePopupVisible, setIsSimplePopupVisible] = useState(false);
  const [directorioAreas, setDirectorioAreas] = useState([]);
  const [dataSource, setDataSource] = useState(null);
  const [filteredData, setFilteredData] = useState(directorioAreas);
  const [searchText, setSearchText] = useState('');
  const [selectedAreaDataSource, setSelectedAreaDataSource] = useState([]);
  const [selectedAreaSimple, setSelectedAreaSimple] = useState();
  const [areaDataSource, setAreasDataSource] = useState([]);
  const [estructurasJerarquicas, setEstructurasJerarquicas] = useState([]);
  const [filteredAreasByStructure, setFilteredAreasByStructure] = useState([]);
  const [isSearchInputDisabled, setIsSearchInputDisabled] = useState(true);
  const [plazasPorArea, setPlazasPorArea] = useState(null);
  const [selectedAreaPuestosInfo, setSelectedAreaPuestosInfo] = useState([]);

  const fetchInitialData = async () => {
    setIsLoadingVisible(true);
    const [
      _directorioDeAreas,
      _estructurasJerarquicas,
      _plazasPorArea,
    ] = await Promise.all([
      getAllAreas(),
      getAllEstructurasJerarquicas(),
      getAsignacionPlazasOptimized(),
    ]);

    setDirectorioAreas(_directorioDeAreas);
    setPlazasPorArea(_plazasPorArea);

    // setDataSource(
    //   new ArrayStore({
    //     key: 'id',
    //     data: _directorioDeAreas,
    //   }),
    // );
    setEstructurasJerarquicas(_estructurasJerarquicas);
    setIsLoadingVisible(false);
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const showInfo = useCallback(
    (employee) => {
      setCurrentEmployee(employee);
      setPopupVisible(true);
    },
    [setCurrentEmployee, setPopupVisible],
  );

  const hideInfo = useCallback(() => {
    setCurrentEmployee({});
    setPopupVisible(false);
  }, [setCurrentEmployee, setPopupVisible]);

  const customShapeTemplate = useCallback(
    (item) => Organigrama_customShape(item.dataItem, () => {
      showInfo(item.dataItem);
    }),
    [showInfo],
  );

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);
    if (value.trim().length > 0) {
      const filtered = filteredAreasByStructure.filter((item) => item.nombre.toLowerCase().includes(value.toLowerCase()));
      setFilteredData(filtered);
    } else {
      setFilteredData(filteredAreasByStructure);
    }
  };

  const getAreaWithRelations = (_dataArray, id) => {
    const _areasMap = new Map();
    _dataArray.forEach((area) => _areasMap.set(area.id, area));

    const result = new Map();

    const current = _areasMap.get(id);
    if (!current) return [];

    result.set(current.id, current);

    let parentId = current.directorio_area_padre;
    while (parentId !== null && _areasMap.has(parentId)) {
      const parent = _areasMap.get(parentId);
      result.set(parent.id, parent);
      parentId = parent.directorio_area_padre;
    }

    function findChildren(parent) {
      _dataArray.forEach((area) => {
        if (area.directorio_area_padre === parent && !result.has(area.id)) {
          result.set(area.id, area);
          findChildren(area.id);
        }
      });
    }
    findChildren(id);

    return Array.from(result.values());
  };

  const getTotalPlacementsCount = ({ id }) => {
    const count = new Map();
    const plazasFilter = plazasPorArea
      .filter((item) => item.directorio_area_id === id)
      .map((item) => ({
        numeroPuesto: item.puesto_id,
        puesto: item.puesto,
      }));

    plazasFilter.forEach((item) => {
      const { numeroPuesto, puesto } = item;

      if (count.has(numeroPuesto)) {
        count.get(numeroPuesto).cantidad += 1;
      } else {
        count.set(numeroPuesto, { numeroPuesto, puesto, cantidad: 1 });
      }
    });

    setSelectedAreaPuestosInfo(Array.from(count.values()));
  };

  const CustomCard = ({ employee }) => (
    <Card
      style={{ marginTop: '10px', border: '1px solid #d9d9d9' }}
      bordered
      actions={[
        <EyeOutlined
          key="view"
          onClick={() => {
            setSelectedAreaSimple(employee);

            const result = getAreaWithRelations(
              filteredAreasByStructure,
              employee.id,
            );
            setSelectedAreaDataSource(result);
            setAreasDataSource(result);
            getTotalPlacementsCount(employee);
            setIsSimplePopupVisible(true);
          }}
        />,
      ]}
    >
      <b>{employee.nombre}</b>
    </Card>
  );

  return (
    <Spin tip="Cargando..." spinning={isLoadingVisible}>
      <div className="container">

        <Form
          layout="vertical"
          name="areas"
        >
          <Row gutter={10}>
            <Col
              xs={24}
              sm={24}
              md={4}
            >
              <Form.Item
                name="estructuraJerarquica"
                label="Estructura Jerárquica"
              >
                <Select
                  keyProp="id"
                  labelProp="nombre"
                  dataSource={estructurasJerarquicas}
                  onChange={(item) => {
                    if (item) {
                      const estructuraSeleccionada = estructurasJerarquicas.find((estructura) => estructura.id === item);
                      const areasByStructure = directorioAreas.filter((area) => area.estructura_jerarquica === estructuraSeleccionada.id);
                      setSearchText('');
                      setFilteredAreasByStructure(areasByStructure);
                      setFilteredData(areasByStructure);
                      setIsSearchInputDisabled(false);
                      setDataSource(
                        new ArrayStore({
                          key: 'id',
                          data: areasByStructure,
                        }),
                      );
                    } else {
                      setFilteredAreasByStructure([]);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={4}>
              <Form.Item
                name="area"
                label="Área"
              >
                <Input
                  size="middle"
                  placeholder="Buscar área"
                  prefix={<SearchOutlined />}
                  onChange={handleSearch}
                  disabled={isSearchInputDisabled}
                  value={searchText}
                />
              </Form.Item>
            </Col>

          </Row>
        </Form>

        <Row>
          <Col
            xs={24}
            sm={24}
            md={4}
            style={{ height: 'calc(100vh - 200px)', overflowY: 'auto' }}
          >
            {filteredData.map((currentEmployeeMap) => <CustomCard employee={currentEmployeeMap} />)}
          </Col>
          <Col
            xs={0}
            sm={0}
            md={20}
          >
            {directorioAreas.length > 0 && dataSource && (
              <Diagram
                id="diagram"
                customShapeRender={customShapeTemplate}
                readOnly
              >
                {directorioAreas.map((employee) => (
                  <CustomShape
                    type={`employee${employee.id}`}
                    baseType="rectangle"
                    defaultWidth={2}
                    defaultHeight={1.5}
                    allowEditText={false}
                    allowResize={false}
                    key={employee.id}
                  />
                ))}
                <Nodes
                  dataSource={dataSource}
                  keyExpr="id"
                  typeExpr={itemTypeExpr}
                  parentKeyExpr="directorio_area_padre"
                >
                  <AutoLayout type="tree" />
                </Nodes>
              </Diagram>
            )}
          </Col>
        </Row>

        <Popup
          visible={popupVisible}
          onHiding={hideInfo}
          dragEnabled={false}
          title="Información"
          width={350}
          height={500}
        >
          <Row style={{ ...styles.popup, textAlign: 'center' }}>
            <Col span={24}>
              <img src={logo} alt="Company Logo" />
            </Col>
            <Col span={24}>
              <p>
                <b>{currentEmployee.nombre}</b>
              </p>
            </Col>
          </Row>

          <Row style={styles.popup}>
            <Col flex="120px">Área dependiente</Col>
            <Col flex="auto">
              {' '}
              {
                directorioAreas.find(
                  (item) => item.id === currentEmployee.directorio_area_padre,
                )?.nombre
              }
            </Col>
          </Row>
          <Row style={styles.popup}>
            <Col flex="120px">Plazas totales</Col>
            <Col flex="auto">{currentEmployee.total_plazas}</Col>
          </Row>
          <Row style={styles.popup}>
            <Col flex="120px">Plazas ocupados</Col>
            <Col flex="auto">{currentEmployee.total_plazas_asignadas}</Col>
          </Row>
          <Row style={styles.popup}>
            <Col flex="120px">Plazas disponibles</Col>
            <Col flex="auto">{currentEmployee.total_plazas_disponibles}</Col>
          </Row>
          <Row style={styles.popup}>
            <Col flex="120px">Visión</Col>
            <Col flex="auto">{currentEmployee.vision}</Col>
          </Row>
          <Row style={styles.popup}>
            <Col flex="120px">Misión</Col>
            <Col flex="auto">{currentEmployee.mision}</Col>
          </Row>
        </Popup>

        <Popup
          visible={isSimplePopupVisible}
          onHiding={() => setIsSimplePopupVisible(false)}
          dragEnabled={false}
          title="Información"
          width="90%"
          height="90%"
          position={{ of: window }}
        >
          {' '}
          {/* <-- NO QUITAR, sinó no renderiza XD */}
          {Array.isArray(selectedAreaDataSource)
            && selectedAreaDataSource.length > 0
            && areaDataSource && (
              <div>
                <Tabs defaultActiveKey="1">
                  <Tabs.TabPane
                    tab="Información"
                    key="1"
                  >
                    <Row>
                      <Col
                        xs={24}
                        sm={24}
                        md={6}
                      >
                        <div className="site-card-border-less-wrapper">
                          <Card
                            title={selectedAreaSimple.nombre}
                            bordered
                          >
                            <p>
                              <KeyOutlined />
                              Clave:
                              {' '}
                              <b>{selectedAreaSimple.clave}</b>
                            </p>
                            <p>
                              <UserOutlined />
                              Plazas Totales:
                              {' '}
                              <b>
                                {selectedAreaSimple.total_plazas}
                              </b>
                            </p>
                            <p>
                              <UserOutlined style={{ color: 'green' }} />
                              Plazas Asignadas:
                              {' '}
                              <b>
                                {selectedAreaSimple.total_plazas_asignadas}
                              </b>
                            </p>
                            <p>
                              <UserDeleteOutlined style={{ color: 'red' }} />
                              {' '}
                              Plazas Vacantes:
                              {' '}
                              <b>
                                {selectedAreaSimple.total_plazas_disponibles}
                              </b>
                            </p>
                            <p>
                              <AimOutlined />
                              Misión:
                              {' '}
                              <b>{selectedAreaSimple.mision}</b>
                            </p>
                            <p>
                              {' '}
                              <EyeOutlined />
                              Vision:
                              {' '}
                              <b>{selectedAreaSimple.vision}</b>
                            </p>
                          </Card>
                        </div>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={10}
                      >
                        <div className="site-card-border-less-wrapper">
                          <Card
                            title="PLAZAS"
                            bordered
                          >
                            {
                              selectedAreaPuestosInfo.map(({ numeroPuesto, puesto, cantidad }) => (
                                <p>
                                  <UserOutlined />
                                  <b>
                                    {' '}
                                    {numeroPuesto} - {puesto}: {cantidad}
                                  </b>
                                </p>
                              ))
                            }
                          </Card>
                        </div>
                      </Col>
                    </Row>
                  </Tabs.TabPane>
                  <Tabs.TabPane
                    tab="Diagrama"
                    key="2"
                  >
                    <Diagram
                      key={JSON.stringify(selectedAreaDataSource)}
                      id="diagram_simple"
                      customShapeRender={customShapeTemplate}
                      readOnly
                    >
                      {selectedAreaDataSource.map((employee) => (
                        <CustomShape
                          key={employee.id}
                          type={`employee${employee.id}`}
                          baseType="rectangle"
                          defaultWidth={2}
                          defaultHeight={1.5}
                          allowEditText={false}
                          allowResize={false}
                        />
                      ))}
                      <Nodes
                        dataSource={areaDataSource}
                        keyExpr="id"
                        typeExpr={itemTypeExpr}
                        parentKeyExpr="directorio_area_padre"
                      >
                        <AutoLayout type="tree" />
                      </Nodes>
                    </Diagram>
                  </Tabs.TabPane>
                </Tabs>
              </div>
          )}
        </Popup>
      </div>
    </Spin>
  );
};

export default Organigrama;
